import React from "react";

function I2WLabel({ item, isSmall = false }) {
  let ppClassName = "text-xs py-0 px-2 font-semibold";

  if (item.__isI2wRule) {
    ppClassName += " bg-green-200 text-green-700";
    if (isSmall) {
      return <span className={ppClassName}>I2W</span>;
    }

    return <span className={ppClassName}>Intowow</span>;
  }

  return "";
}

export default I2WLabel;
